import { createFileRoute } from '@tanstack/react-router';
import Goods from '../../../features/baseData/goods/goods';
import {
  createPermissionGuard,
  getPermissionSet,
  GOODS_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gueter/')({
  component: Goods,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GOODS_PERMISSIONS, 'READ'),
  ),
});

export const ListGoodsRoute = Route;
